import React from 'react';
export function PromoBar() {
  return <div className="border-b border-night-600 bg-night-950" data-id="element-312" data-mp="2sdgds1vbnv9c">
      <div className="mx-auto flex max-w-shell items-center justify-center px-5 py-2.5 sm:px-6" data-id="element-313" data-mp="895i0a0ld9yo">
        <p className="text-center text-[11px] leading-snug text-cream sm:text-sm" data-id="element-314" data-mp="3hxa5iewtwnm">
          <span className="font-bold uppercase tracking-wider text-amber" data-id="element-315" data-mp="3up9pdrw8g00w">Cena premierowa</span>
          <span className="text-cream-muted" data-id="element-316" data-mp="3qn52dc0ai1n8"> · </span>
          Cały semestr zaplanowany
          <span className="text-cream-muted" data-id="element-317" data-mp="3lobnpg99o4lh"> · </span>
          10 dni gwarancji
        </p>
      </div>
    </div>;
}